<template>
    <div class="popup-wrap" @click="closePopup()" v-if="popupVisible">
        <div class="popup-window">
          <div class="close-popup"> &#215; </div>
                <h2>Szanowni Państwo</h2>
                <p>Uprzejmie informujemy,
                  <br>że w dniu <b>16.08</b> infolinia jest czynna
                  <br>w godzinach <b>10:00-16:00</b>,
                  <br>a  w dniu <b>17.08</b> w godzinach <b>10:00-15:00</b>.
                </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PopupContact",
        data() {
            return {
                popupVisible: false
            }
        },
        methods: {
            closePopup() {
                this.popupVisible = false;
            }
        }
    }
</script>

<style scoped>
    .popup-wrap {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .6);
        z-index: 9999;
    }
    .close-popup {
      position: absolute;
      color: #89ccca;
      padding: 1em 1.5em;
      cursor: pointer;
      right: 0;
      top: 0;
      font-weight: bold;
      font-size: 1.2em;
    }
    .popup-wrap .popup-window {
        border-radius: 4px;
        margin: auto;
        padding: 2em;
        background-color: white;
        color: black;
        -webkit-box-shadow: 10px 10px 30px rgba(0, 0, 0, .2);
        box-shadow: 10px 10px 30px rgba(0, 0, 0, .2);
        width: 74%;
        height: 47vw;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
    }
    .popup-wrap .popup-window p,
    .popup-wrap .popup-window h2
    {
        text-align: center;
        color: #666;
    }

    @media screen and (min-width: 1024px) {
        .popup-wrap .popup-window {
            width: 25vw;
            height: 12vw;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Popups/PopupContact.vue